import createVerityCheckboxLogger from "./verity-checkbox";
import createSaveButtonLogger from "./save-button";
import createConfigurationModalLogger from "./configuration-modal";
export default function createEditAssessmentLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `edit:${input.type}` });
    return {
        detected(details) {
            return log({
                type: "detected",
                details,
            });
        },
        verityCheckbox: createVerityCheckboxLogger(log),
        saveButton: createSaveButtonLogger(log),
        configurationModal: createConfigurationModalLogger(log),
    };
}
